/**
 * Stroke dash patterns for line chart styling.
 */
export const STROKE_DASHARRAYS = {
  dashed: '6, 4',
  dotted: '2, 1',
  solid: 'none',
} as const satisfies Record<string, string>;

/**
 * Label dimension estimation constants.
 */
export const MIN_Y_MARGIN = 40;
export const CHAR_WIDTH = 8;
export const Y_PADDING = 16;
export const X_AXIS_HEIGHT_SHORT = 30;
export const X_AXIS_HEIGHT_LONG = 50;
